import {
  NgModule
} from '@angular/core';
import {
  RouterModule,
  Routes
} from '@angular/router';
import { CanDeactivateGuard } from 'src/app/@core/guards/can-deactivate.guard';
import {
  PosCustomerCreateComponent
} from 'src/app/shared/pos-customer-create/pos-customer-create.component';
import {
  PosCustomerUpdateComponent
} from 'src/app/shared/pos-customer-update/pos-customer-update.component';
import { PosPaymentMethodComponent } from 'src/app/shared/pos-payment-method/pos-payment-method.component';

import * as fromComponents from './components';
import {
  AdvanceComponent
} from './components/advance/advance.component';
import { AdvanceCreateComponent } from './components/customer-advances/advance-create/advance-create.component';

const routes: Routes = [{
  path: '',
  component: fromComponents.PosCustomerComponent,
  children: [
    {
      path: '',
      component: fromComponents.CustomerIdentificationComponent,
      data: {
        title: 'Clientes',
        id: 'CustomerIdentificationComponent_customer'
      },
      canDeactivate: [CanDeactivateGuard]
    },
    {
      path: 'create',
      component: PosCustomerCreateComponent,
      data: {
        title: 'Crear cliente',
        id: 'PosCustomerCreateComponent_create'
      },
    },
    {
      path: ':id',
      component: fromComponents.CustomerIdentificationComponent,
      data: {
        title: 'Clientes',
        id: 'CustomerIdentificationComponent_id'
      },
    },
    {
      path: 'update/:id',
      component: PosCustomerUpdateComponent,
      data: {
        title: 'Modificar cliente',
        id: 'PosCustomerUpdateComponent_update_id'
      },
    },
    {
      path: 'advance/:clientId',
      component: AdvanceComponent,
      data: {
        title: 'Anticipos por cliente',
        id: 'AdvanceComponent_advance_clientId'
      }
    }, {
      path: 'loansactive/:id',
      component: fromComponents.CustomerLoansActiveComponent,
      data: {
        title: 'Prestamos activos',
        id: 'CustomerLoansActiveComponent_loansactive'
      },
    },
    {
      path: "advances/:id/create",
      component: AdvanceCreateComponent,
      data: {
        title: "Crear Anticipo",
        id: "AdvanceComponent_advance_clientId"
      }
    },
    {
      path: 'advances/:id',
      component: fromComponents.CustomerAdvancesComponent,
      data: {
        title: 'Anticipos de clientes',
        id: 'CustomerAdvancesComponent_advances_id'
      }
    },
    {
      path: 'payment/:id',
      component: PosPaymentMethodComponent,
      data: {
        title: 'Metodos de pago',
        id: 'PosPaymentMethodComponent_payment_id'
      }
    },
    {
      path: 'returnContract/:contractNumber',
      component: fromComponents.StandAloneReturnContractComponent,
      data: {
        title: 'Devolucion de Contratos',
        id: 'StandAloneReturnContractComponent_returnContract'
      }
    }, {
      path: 'returnContractDetail/:contractNumber',
      component: fromComponents.StandAloneReturnContractDetailComponent,
      data: {
        title: 'Detalle de devolucion de contrato',
        id: 'StandAloneReturnContractDetailComponent_detailReturnContract'
      }
    }, {
      path: 'printBalanceRecord/:id',
      component: fromComponents.CustomerBalanceRecordModalComponent,
      data: {
        title: 'Impresion de Constancia de Saldos',
        id: 'CustomerBalanceRecordModalComponent_printBalanceRecord'
      }
    },{
      path:'creditReference/:id',
      component:fromComponents.CustomerCreditReferenceComponent,
      data:{
        title: 'Referencia crediticia',
        id:'CreditReferenceComponent_printCreditReference'
      }
    }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomersRoutingModule { }
